import { createNavigationContainerRef } from "@react-navigation/core";

export const navigatorRef = createNavigationContainerRef();

export const navigate = (name, params = {}, push = false) => {
  if (navigatorRef.isReady()) {
    navigatorRef.current?.navigate(name as never, params as never);
  }
};
